import React, {useContext, useEffect} from 'react';
import {useIntl} from 'react-intl';
import {useKeycloak} from '@react-keycloak/web';
import PropTypes from 'prop-types';

import './index.style.less';
import {message} from 'antd';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import MediaHeader from '../MediaHeader';
import MediaGrid from './MediaGrid';
import MediaList from './MediaList';
import {MediaContext} from '../MediaContext';
import MediaDetail from '../MediaDetail';
import MediaEditor from '../MediaEditor';

import {findMedia} from 'services/MediaService';
import {handleError} from 'utils/MessageUtils';
import {EQUAL} from 'shared/constants/QueryModes';
import {QUERY_SIZE_LIMIT, ReferenceType} from 'shared/constants/AppConst';

const MediaListing = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const mediaContext = useContext(MediaContext);
  const {
    viewType,
    setMediaList,
    setSelectedRef,
    setReadOnly,
    setLoading,
    reloading,
    setReloading,
  } = mediaContext;
  const {requestId, orderId, treatmentId, readOnly} = props;

  const loadData = () => {
    let mediaPromise = Promise.resolve();

    if (requestId?.length > 0) {
      setSelectedRef({
        id: requestId,
        type: ReferenceType.SERVICE_REQUEST,
      });

      mediaPromise = findMedia(headers, {
        pagination: {current: 1, pageSize: QUERY_SIZE_LIMIT},
        filters: [
          {
            fields: 'reference.id',
            mode: EQUAL,
            value: requestId,
          },
          {
            fields: 'reference.type',
            mode: EQUAL,
            value: ReferenceType.SERVICE_REQUEST,
          },
        ],
      });
    } else if (orderId?.length > 0) {
      setSelectedRef({
        id: orderId,
        type: ReferenceType.ORDER,
      });

      mediaPromise = findMedia(headers, {
        pagination: {current: 1, pageSize: QUERY_SIZE_LIMIT},
        filters: [
          {
            fields: 'reference.id',
            mode: EQUAL,
            value: orderId,
          },
          {
            fields: 'reference.type',
            mode: EQUAL,
            value: ReferenceType.ORDER,
          },
        ],
      });
    } else if (treatmentId?.length > 0) {
      setSelectedRef({
        id: treatmentId,
        type: ReferenceType.TREATMENT,
      });

      mediaPromise = findMedia(headers, {
        pagination: {current: 1, pageSize: QUERY_SIZE_LIMIT},
        filters: [
          {
            fields: 'reference.id',
            mode: EQUAL,
            value: treatmentId,
          },
          {
            fields: 'reference.type',
            mode: EQUAL,
            value: ReferenceType.TREATMENT,
          },
        ],
      });
    }

    setLoading(true);
    mediaPromise
      .then((res) => {
        return Promise.all(
          res.data.map((media) => Promise.resolve(media)),
        ).then((values) => setMediaList(values));
      })
      .catch((error) => handleError(message, error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    setReadOnly(!!readOnly);
  }, [readOnly]);

  useEffect(() => {
    if (reloading) {
      loadData();
      setReloading(false);
    }
  }, [reloading]);

  return (
    <div className='product-list-view'>
      <AppsHeader>
        <MediaHeader />
      </AppsHeader>

      <AppsContent>
        <div className='product-list-main-content'>
          {viewType === 'GRID' ? <MediaGrid /> : <MediaList />}
        </div>
        <MediaDetail />
        <MediaEditor />
      </AppsContent>
    </div>
  );
};

export default MediaListing;

MediaListing.propTypes = {
  requestId: PropTypes.string,
  orderId: PropTypes.string,
  treatmentId: PropTypes.string,
  patientId: PropTypes.string,
  practitionerId: PropTypes.string,
  readOnly: PropTypes.bool,
};
